import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { Plan } from "src/app/shared/model/security/plan.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

/** Planes de MI empresa: qué módulos tiene contratados. Sólo lectura. */
@Injectable({
  providedIn: "root",
})
export class PlanesService {
  constructor(private http: HttpClient) {}

  consultarPlanes(): Observable<ConsultaList<Plan>> {
    return this.http.post<ConsultaList<Plan>>(UrlConstantes.PLANES_CONSULTAR, {});
  }
}
